// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__skJYa","nameTextWrapper":"style_nameTextWrapper__g5efT","dateText":"style_dateText__n8U0e"};